<template>
  <button class="highlight-button"><slot></slot></button>
</template>

<script>
export default {
  props: {},
};
</script>

<style lang="scss">
@use "~/_colors.scss" as *;

@keyframes btn-anim {
  from {
    transform: scale(0.95, 0.95);
  }
}

.highlight-button {
  transition: 0.3s linear;
  padding: 1rem;
  border-radius: 5px;
  background: $highlight-color;
  color: white;
  border: none;
  color: black;
  animation-name: btn-anim;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-duration: 1s;

  &:hover {
    background: darken($highlight-color, 25%);
  }
}
</style>
